'use client';

import { uiService } from '@/services/ui.service';

export const SidebarOverlay = () => {
	const closeSidebar = () => {
		uiService.controlSidebar(false);
	};

	return (
		<div 
			className="side-nav-backdrop"
			onClick={closeSidebar}
		>
		</div>
	);
};